<template>
  <div class="account-change-password">
    <h4 class="font-weight-bold text-center">Alterar senha</h4>
    <form @submit.prevent="submit">
      <form-group
        id="password_old"
        v-model="form.password_old"
        :errors="errors.password_old"
        type="password"
        label="Senha atual"
      />

      <form-group
        id="password"
        v-model="form.password"
        :errors="errors.password"
        type="password"
        label="Nova senha"
      />

      <button
        type="submit"
        class="btn btn-primary btn-block px-5"
        :disabled="loading"
      >
        <loading :show="loading">Salvar</loading>
      </button>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  data() {
    return {
      loading: false,
      ...formFields(["password_old", "password"])
    };
  },
  methods: {
    submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("user/updatePassword", this.form)
        .then(() => {
          this.$message.success("Senha alterada com sucesso!");
          setTimeout(() => {
            this.$router.push({ name: "home" });
          }, 2500);
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
